var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 4 16"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#1d232d","d":"M.5 8a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0-6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }